// Retina Images from http://retina-images.complexcompulsions.com/
document.cookie='devicePixelRatio='+((window.devicePixelRatio === undefined) ? 1 : window.devicePixelRatio)+'; path=/';